import { startOfDay } from 'date-fns'
import {blueColor, DodgerBlueColor, oceanBlueColor} from '../../cmsMainStyle'

const uploadDrawingFormStyle = theme => ({
	column: {
		display: "flex",
		// justifyContent: "center",
		alignItems: "center",
		textAlign: 'center',
		// fontWeight: 'bold',
		padding: 2,
		backgroundColor: blueColor[3],
	},

	content: {
		display: "flex",
		// alignItems: "center",
		// alignItems: "flexStart",
		textAlign: 'center',
	},

	itemPaper: {
		width: "100%",
		margin: 10,
		padding: 10,
		background: "rgba(230, 245, 255, 0.3)"
	},

	uploadArea: {
		height: window.outerHeight - (window.outerHeight - window.innerHeight + 300),
		overflowY: "auto",
		overflowX: "hidden",
	},


	addFileBtnArea: {
		textAlign: "center",
		// paddingTop: theme.spacing(1),
		// paddingBottom: theme.spacing(1),
	},

	uploadAreaBtn: {
		background: DodgerBlueColor[11],
		'&:hover': {
			background: DodgerBlueColor[13],
		},

		marginTop: theme.spacing(1),
		marginLeft: theme.spacing(1),
		marginRight: theme.spacing(1),
	},

	datePickerField: {
		// marginBottom: theme.spacing(0),
		width: '100%',
	},



//////////////////////////////////////

	drawingPropertyArea: {

		paddingTop: theme.spacing(2),
		paddingBottom: theme.spacing(1),
		paddingLeft: theme.spacing(1),
		paddingRight: theme.spacing(1)
	},


	drawingFieldArea: {
		textAlign: "center",
		// marginTop: theme.spacing(1),
		// marginBottom: theme.spacing(1),
	},


	coverTypeGrid: {
		textAlign: "center",
		marginTop: theme.spacing(2),
		// marginBottom: theme.spacing(1),
	},

	LegendArea: {
		textAlign: "left",
		marginTop: theme.spacing(3)
	},

	ToggleButtonGroup: {
		width: "100%",
		
	},

	ToggleButton: {
		width: "33%",
		"&.Mui-selected": {
			backgroundColor: oceanBlueColor[1]
		}
	},

	coverInfoArea: {
		margin: theme.spacing(2)
	}


})


export {uploadDrawingFormStyle}